export const addItemToLocalStorage = (itemKey, itemValue) => {
  localStorage.setItem(itemKey, itemValue);
};

export const getItemFromLocalStorage = itemKey => localStorage.getItem(itemKey);

export const removeItemFromLocalStorage = itemKey => {
  localStorage.removeItem(itemKey);
};
